import { Vue, i18n } from 'Common/vue';
import Comparison from 'VueComponents/Comparison.vue';

import "Layouts/default";

import 'Common/recommendation';

window.$_comparison = new Vue({
    i18n,
    render: h => h(Comparison)
}).$mount("#comparison");

Event.on('Comparison.countUpdated', (data) => {
    document.querySelector('.js-compare-badge').innerHTML = data.count;
});

Event.on('Cart.fetchedComparisonProducts', () => {
    setTimeout(() => {
        syncscroll.reset();
    }, 250);
});

